<template>
  <div class="smartkeyAuth notranslate">
    <div class="title mb30">
      <h2>{{ locale.smartkey }}</h2>
      <p>{{locale.smartkey_auth_title}}</p>
    </div>
    <div class="formGroup mb15">
      <input
        type="text"
        class="input"
        :placeholder="locale.placeholder_input_space"
        v-model="spaceid"
        @keyup.enter="setAuth" />
    </div>
    <div v-if="message" class="message colorRed mb15">
      {{ locale[`message_smartkey_${message}`] }}
      <div v-if="messageLog" class="messageLog mt5">
        <p
          v-for="(message, index) in messageLog"
          :key="index">
          {{ message }}
        </p>
      </div>
    </div>
    <div class="formGroup">
      <button type="button" class="btn btnRound btnFull" @click="setAuth">{{locale.do_auth}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'ln',
    'locale',
    'isPublic'
  ],
  computed: {
    authInfo () {
      return this.$store.getters['authentication/getAuthInfo']
    }
  },
  async created () {
    const authInfo = this.authInfo
    const site = authInfo.site
    const space = authInfo.spaceCode
    const storageItem = `smartkey_${site}_${space}`
    const storage = localStorage.getItem(storageItem)
    // 이미 인증한 적이 있다면 view 페이지로 넘김
    if (storage) {
      const storageData = storage && JSON.parse(storage)
      const storageKey = storageData && storageData.keyOtaId
      const sotrageSpaceid = storageData && storageData.spaceid
      const keyOtaId = authInfo.keyOtaId
      if (storageKey === keyOtaId) { // 인증한 적이 있다면 유효한지 검사한 뒤 router 이동
        this.$store.commit('loading', true)
        this.$store.dispatch('guest/getMobileKey').then((res) => {
          if (res && res.status && res.status === 200) {
            const sendResult = res.data && res.data.message
            const code = sendResult && sendResult.code
            const key = sendResult && sendResult.mobileKey
            const linkPageId = storageData.linkPageId
            if (key) {
              this.$router.push({
                name: linkPageId ? 'page' : 'mobilekeyView', // 스마트키 페이지는 기본(View.vue) 또는 커스텀페이지(page_uuid)임
                ...linkPageId && {
                  params: {
                    id: linkPageId // 커스텀페이지id
                  }
                }
              })
            } else {
              const errorCode = code || res.message && res.message.code || 500
              const errorMessage = this.getResultData(errorCode)
              this.message = errorMessage
              if (errorCode === 401) {
                this.messageLog = res.message.reason && res.message.reason.map(x => x.message.replace(/\"/g, '"'))
              }
            }
          } else {
            const errorCode = res && res.message && res.message.code || 500
            const errorMessage = this.getResultData(errorCode)
            this.message = errorMessage
            if (errorCode === 401) {
              this.messageLog = res.message.reason && res.message.reason.map(x => x.message.replace(/\"/g, '"'))
            }
          }
          this.$store.commit('loading', false)
        })
      }
    }
  },
  data () {
    return {
      spaceid: '',
      message: '',
      messageLog: null
    }
  },
  methods: {
    getResultData (code) {
      return this.$store.getters['guest/getSmartkeyResultData'](code)
    },
    setAuth () {
      const authInfo = this.authInfo
      const site = authInfo.site
      const space = authInfo.spaceCode // 스마트키가 있는 공간
      const keyOtaId = authInfo.keyOtaId // 스마트키 호출을 위한 유니크id로 이 키와 매핑된 spaceid(객실, 라커 등)로 인증
      const spaceid = this.spaceid // 객실
      const data = {
        keyOtaId: keyOtaId,
        spaceCode: space,
        authType: 'space',
        authData: spaceid
      }
      this.message = ''
      this.messageLog = null
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/authMobileKey', data).then((res) => {
        if (res && res.status && res.status === 200) {
          const sendResult = res.data && res.data.message
          const linkPageId = sendResult && sendResult.linkPageId
          if (sendResult && sendResult.keyOtaId && sendResult.spaceCode && sendResult.space) {
            const storageKey = `smartkey_${site}_${sendResult.spaceCode}`
            const info = {
              keyOtaId: sendResult.keyOtaId,
              spaceid: sendResult.space,
              ...linkPageId && {
                linkPageId: linkPageId
              }
            }
            // 인증된 키만 로컬스토리지에 저장 후 스마트키를 호출한다
            localStorage.setItem(storageKey, JSON.stringify(info))
            this.$router.push({
              name: linkPageId ? 'page' : 'mobilekeyView', // 스마트키 페이지는 기본(View.vue) 또는 커스텀페이지(page_uuid)임
              ...linkPageId && {
                params: {
                  id: linkPageId // 커스텀페이지id
                }
              }
            })
          } else {
            // system error
          }
        } else {
          const errorCode = res && res.message && res.message.code || 500
          const errorMessage = this.getResultData(errorCode)
          this.message = errorMessage
          if (errorCode === 401) {
            this.messageLog = res.message.reason && res.message.reason.map(x => x.message.replace(/\"/g, '"'))
          }
        }
        this.spaceid = ''
        this.$store.commit('loading', false)
      })
    }
  }
}
</script>

